import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

export default function useProctoringEKycListSearchParams() {
  const [{ search, page, pageSize }, setQueryParams] = useQueryStates({
    search: parseAsString.withDefault(''),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(50),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };
  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize });
  };
  const changeSearch = (search: string) => {
    setQueryParams({ search });
  };

  return [
    {
      search,
      page,
      pageSize,
    },
    { changePageNumber, changePageSize, changeSearch },
  ] as const;
}
